<template>
  <div
    id="chatbox"
    ref="chatbox"
    v-resize="onResizeChatbox"
    :style="{ height: chatboxHeight, 'overflow-y': isMobile ? 'hidden' : 'auto' }"
  >
    <!-- @scroll="onMessageScroll" -->
    <template v-if="selectedUser">
      <v-toolbar
        dark
        color="primary"
        flat
        :absolute="!isMobile"
        :fixed="isMobile"
        style="top: 0; background: #ff9d85"
        :style="{ top: isMobile ? '56px' : '0px' }"
      >
        <v-btn
          flat
          dark
          fab
          small
          class="ma-0 btn-back extra-small"
          @click="$emit('onClose')"
          v-show="isMobile"
        >
          <v-icon medium>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text text-truncate"
          >{{ selectedUser.first_name }} {{ selectedUser.last_name }}</v-toolbar-title
        >

        <v-spacer></v-spacer>
        <v-btn
          flat
          dark
          fab
          small
          class="ma-0 btn-back"
          @click="$emit('onShowTool')"
          v-show="isMobile"
        >
          <v-icon medium>settings_applications</v-icon>
        </v-btn>
        <div v-show="!isMobile">
          <v-btn
            color="white"
            small
            outline
            @click="endSession"
            v-if="selectedUser.context == 'contactadmin'"
            style="line-height: 0"
            >{{ $t('Switch to bot') }}</v-btn
          >
          <v-btn
            color="white"
            small
            outline
            @click="openSession"
            v-else-if="selectedUser.context != 'contactadmin'"
            style="line-height: 0"
            >{{ $t('Switch to admin') }}</v-btn
          >
          <cooldown :delay="3" cname="refresh_chat_user" @onLoad="onRefresh">
            <template v-slot="{ zloading, onClick, show }">
              <v-btn v-if="show" icon @click="onClick" :loading="zloading">
                <v-icon>refresh</v-icon>
              </v-btn>
            </template>
            <template v-slot:countdown="{ show, delaytime, onCountdownEnd }">
              <template v-if="show && delaytime !== true && delaytime > 0">
                <v-btn v-if="show" icon :loading="true">
                  <v-icon>refresh</v-icon>
                  <countdown :time="delaytime * 1000" @end="onCountdownEnd"> </countdown>
                </v-btn>
              </template>
            </template>
          </cooldown>
        </div>
      </v-toolbar>
      <div
        id="chatbox-container"
        style="position: relative"
        :style="{
          'padding-bottom': chatinputHeight + 'px',
          'margin-top': isMobile ? '56px' : '0px',
          top: isMobile ? '0px' : '85px'
        }"
      >
        <template v-if="messages.length > 0">
          <div id="messages">
            <template v-if="isMobile">
              <div
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px; cursor: pointer"
                @click="onLoadmore"
              >
                <template v-if="loadmore">
                  <v-progress-circular
                    indeterminate
                    color="grey"
                    small
                    class="mr-2"
                    :width="2"
                  ></v-progress-circular
                  >Loading
                </template>
                <template v-else @click="onLoadmore">Click to load more conversation</template>
              </div>
            </template>
            <template v-else>
              <div
                v-if="loadmore"
                class="text-xs-center"
                style="background: #eee; padding-top: 10px; padding-bottom: 10px"
              >
                <v-progress-circular
                  indeterminate
                  color="grey"
                  small
                  class="mr-2"
                  :width="2"
                ></v-progress-circular
                >Loading
              </div>
            </template>
            <template v-for="(message, index) in messagesCheckmessageinDay">
              <div v-if="message.showDate" style="width: 100%" :key="index">
                <v-divider style="border-color: #ee6e73"></v-divider>
                <div
                  class="text-center"
                  style="margin-top: -12px; display: flex; justify-content: center; width: 100%"
                >
                  <span style="background-color: white; color: #ee6e73">{{
                    shotDate(message.timestamp)
                  }}</span>
                </div>
              </div>
              <message-item
                :id="`message_${message.id}`"
                v-if="messages"
                :key="'message-' + message.id + message.userid + message.pageid"
                v-model="messages[index]"
                :receiver="selectedUser"
              ></message-item>
            </template>
          </div>
        </template>
        <template v-else>
          <v-layout column justify-center fill-height>
            <div class="text-xs-center mt-5" style="color: #eee">
              <img src="/static/img/assets/livechat/no_message.png" alt />
              <p>No message</p>
            </div>
          </v-layout>
        </template>
      </div>
      <chat-input
        id="chatinput"
        :app="'facebook'"
        :hasNewMessage="hasNewMessage"
        :refreshChatInput="refreshChatInput"
        v-model="selectedUser"
        @loadmessage="getLastedMessages"
        @onSendMessage="onSendMessage($event)"
      >
        <!-- <div v-if="!isAutoRefresh" class="text-xs-center" slot="header">
          <v-btn small round color="primary" @click="gotobottom" depressed>
            <v-icon class>arrow_drop_down</v-icon>Go to bottom
          </v-btn>
        </div> -->
      </chat-input>
    </template>
    <template v-else>
      <v-layout column justify-center fill-height>
        <div class="text-xs-center" style="color: #eee">
          <img src="/static/img/assets/livechat/no_user.png" alt />
          <p>Select a user</p>
        </div>
      </v-layout>
    </template>

    <v-snackbar v-model="showSnackbar" bottom right :timeout="3000" :color="'error'">
      Connection fail. Please try again
      <v-btn color="pink" flat fab dark small @click="showSnackbar = false">
        <v-icon small color="white">close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Cooldown from '@/components/elements/Cooldown'
import moment from 'moment'
import messageItem from './MessageItem'
// import chatInput from '@/components/view/livechat/livechat-chatinput'
import chatInput from './ChatInput'

export default {
  props: ['value', 'isMobile', 'selectedUser'],
  components: {
    Cooldown,
    'message-item': messageItem,
    'chat-input': chatInput
  },
  data() {
    return {
      messages: {},
      chatboxHeight: 0,
      loadmore: false,
      chatinputHeight: '130px',
      showSnackbar: false,
      hasNewMessage: false,
      refreshChatInput: null
    }
  },
  created: async function () {
    let vm = this
    this.resetChatlog()
    await this.getLastedMessages()
    await this.wait(1000)
    if (vm.isMobile) {
      document.body.onscroll = function () {
        vm.onMessageScroll()
      }
    }
  },
  mounted() {
    if (this.value) {
      this.messages = this.value
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    messagesCheckmessageinDay() {
      if (this.messages) {
        let output = []
        let messages = this.messages
        let cash_date = null
        messages.forEach((message) => {
          if (message.timestamp) {
            let date = moment(new Date(message.timestamp)).format('YYYY-MM-DD')
            if (cash_date && date == cash_date) {
              output.push({ ...message, showDate: false })
            } else {
              cash_date = date
              output.push({ ...message, showDate: true })
            }
          }
        })
        return output
      } else {
        return []
      }
    }
  },
  methods: {
    shotDate: function (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    onResizeChatbox: function () {
      var vm = this
      vm.$nextTick(function () {
        if (this.isMobile) {
          vm.chatboxHeight = 'auto'
          // vm.chatinputHeight = 0
        } else {
          vm.chatboxHeight =
            window.innerHeight - document.getElementById('main_toolbar').clientHeight - 5 + 'px'
        }
        if (document.getElementById('chatinput')) {
          vm.chatinputHeight = document.getElementById('chatinput').clientHeight
        }
        vm.debug =
          `Chatbox Height: ${vm.chatboxHeight}<br>` +
          `Input Height: ${vm.chatinputHeight}<br>` +
          `Screen Height: ${screen.height}<br>` +
          `Main Toolbar: ${document.getElementById('main_toolbar').clientHeight}<br>` +
          `Window: ${window.innerHeight}<br>`
      })
    },
    async onSendMessage(payload) {
      if (payload.replytype == 'replytocomment') {
        this.messages.push(payload)
        await this.snapBottom()
      } else {
        this.$swal.fire({
          text: 'Send message to inbox successfully.',
          type: 'success'
        })
      }
    },
    getLastedMessages: async function () {
      var vm = this
      let limit = 100

      if (vm.messages.length == 0) {
        limit = 100
      }
      if (!vm.selectedUser) {
        return false
      }

      try {
        await vm.getUserMessages(0, limit, true)
        vm.onResizeChatbox()
        if (vm.isAutoRefresh && document.getElementById('messages')) {
          // $('#chatbox').animate({ scrollTop: document.getElementById('messages').clientHeight })
          await vm.snapBottom()
        }
      } catch (error) {}
    },
    getUserMessages: function (offset, limit, latest) {
      let vm = this
      return new Promise((resolve, reject) => {
        if (vm.selectedBot == null || vm.selectedUser == null || vm.loading) {
          reject()
        }
        vm.loading = true
        let data = {
          pageid: vm.selectedBot.pageid,
          limit: limit,
          offset: offset,
          postid: vm.$store.state.rabbitSelectedPostId,
          userid: vm.selectedUser.userid
        }

        if (!latest) {
          vm.loadmore = true
        }

        api.getRabbitChatlogWithPost(data, function (error, response) {
          if (error) {
            if (!latest) {
              vm.loadmore = false
            }
            vm.showSnackbar = true
            reject(error)
          }

          if (response && response.data) {
            let messages = response.data
            try {
              messages = messages.map((el) => {
                if (el.messagetype == 'json') {
                  let json = []
                  try {
                    json = JSON.parse(el.messagedata)
                  } catch (error) {}
                  let bubbles = json.filter((b) => {
                    if (b.type == 'text' && b.text == '') {
                      return false
                    }
                    return true
                  })

                  return {
                    ...el,
                    messagedata: JSON.stringify(bubbles)
                  }
                }
                return el
              })
            } catch (error) {}

            vm.messages = messages
            vm.loading = false
          }
          resolve()
        })
      })
    },
    onMessageScroll: function () {
      let scrollPosition = 0
      if (this.isMobile) {
        scrollPosition = window.pageYOffset + window.innerHeight
        let totalHeight = document.body.scrollHeight
        // console.log(totalHeight == scrollPosition)
        if (totalHeight == scrollPosition) {
          this.isAutoRefresh = true
        } else {
          this.isAutoRefresh = false
        }
        // console.log(scrollPosition, totalHeight)
        return false
      } else {
        let messages = document.getElementById('chatbox')
        scrollPosition = messages.scrollTop
        let chatboxHeight = messages.clientHeight
        let totalHeight = messages.scrollHeight
        // console.log(scrollPosition, chatboxHeight, totalHeight)
        if (totalHeight - 30 <= scrollPosition + chatboxHeight) {
          this.isAutoRefresh = true
        } else {
          this.isAutoRefresh = false
        }
      }

      if (scrollPosition == 0) {
        this.onLoadmore().then(function () {})
      }
    },
    onLoadmore: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        if (vm.loadmore) {
          reject()
        }
        vm.limit += 100
        vm.getUserMessages(vm.offset, vm.limit, false).then(
          function () {
            // $('#chatbox').animate({ scrollTop: 0 })
            resolve()
          },
          function () {}
        )
      })
    },
    async snapBottom() {
      let vm = this
      if (!vm.isAutoRefresh || vm.loadmore) {
        return false
      }
      await vm.gotobottom()
    },
    async gotobottom() {
      await this.$nextTick()
      let messages = $('#messages')
      if (messages.length > 0) {
        if (this.isMobile) {
          window.scrollTo(
            0,
            document.body.scrollHeight +
              (this.chatinputHeight == 0 ? 114 : this.chatinputHeight * 2)
          )
        } else {
          document
            .getElementById('chatbox')
            .scrollTo(0, document.getElementById('messages').clientHeight)
        }
      }
    },
    resetChatlog: function () {
      this.messages = []
      this.offset = 0
      this.limit = 100
      this.loading = false
      this.loadmore = false
      this.isAutoRefresh = true
    },
    endSession: function () {
      this.$emit('endSession')
    },
    openSession: function () {
      this.$emit('openSession')
    },
    onRefresh: function (payload) {
      var vm = this
      vm.resetChatlog()
      vm.getLastedMessages()

      if (payload) payload.callback()
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.messages = {}
      this.messages = newVal
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/ReplyCommentBox.vue